import PropTypes from 'prop-types';
import React from 'react';

const SelectionBar = ({
  selectedCount,
  onMove,
  onShare,
  shareableItem,
  onDelete,
  onClearSelection
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="asset-selection-bar">
      <span className="selection-bar-count">
        {selectedCount} selected
      </span>
      <button
        className="selection-bar-action"
        onClick={onMove}
        type="button"
      >
        <i className="fas fa-arrows-alt"></i>
        Move
      </button>
      {shareableItem ? (
        <button
          className="selection-bar-action"
          onClick={onShare}
          type="button"
        >
          <i className="far fa-link"></i>
          Share
        </button>
      ) : null}
      <button
        className="selection-bar-action selection-bar-action--danger"
        onClick={onDelete}
        type="button"
      >
        <i className="fas fa-trash"></i>
        Delete
      </button>
      <button
        className="selection-bar-close"
        onClick={onClearSelection}
        type="button"
        title="Clear selection"
      >
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

SelectionBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onMove: PropTypes.func.isRequired,
  onShare: PropTypes.func,
  shareableItem: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired
};

export default SelectionBar;
